import PropTypes from 'prop-types';
import Section from '../Section.jsx';
import styles from './SectionSpotify.module.scss';

function SectionSpotify({ zIndex, debug, showTitlesOnSide, isLast, src }) {
  return (
    <Section zIndex={zIndex} debug={debug} isLast={isLast} showTitlesOnSide={showTitlesOnSide}>
      <iframe
        title="Spotify"
        src={src}
        allowFullScreen
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"
        className={styles.iframe}
      />
    </Section>
  );
}

SectionSpotify.propTypes = {
  zIndex: PropTypes.number,
  debug: PropTypes.bool,
  showTitlesOnSide: PropTypes.bool,
  isLast: PropTypes.bool,
  src: PropTypes.string.isRequired,
};

export default SectionSpotify;
